import { useEffect, useState } from "react";
import { Users, Sparkles, Calendar, UserCog } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { DASHBOARD } from "@/constants/testIds";
import FollowUpKpiCard from "@/components/followups/FollowUpKpiCard";

const StatCard = ({ icon: Icon, label, value, testId }) => (
  <div className="bg-white border border-border rounded-xl p-6 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200" data-testid={testId}>
    <div className="w-10 h-10 rounded-lg bg-brand-light flex items-center justify-center mb-4">
      <Icon className="w-5 h-5 text-brand" />
    </div>
    <p className="text-3xl font-serif text-foreground">{value}</p>
    <p className="text-sm text-muted-foreground mt-1">{label}</p>
  </div>
);

/** Dashboard simple (no financiero) para Recepcion: solo conteos operativos,
 * sin ingresos ni ninguna cifra del negocio. */
export default function ReceptionDashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/dashboard/stats").then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-8">
      <div>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight text-foreground" data-testid={DASHBOARD.welcomeTitle}>
          Hola, {user?.name?.split(" ")[0]}
        </h1>
        <p className="text-base text-muted-foreground mt-2">
          Este es el resumen de {stats?.clinic_name || "tu clínica"}.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard icon={UserCog} label="Miembros del equipo" value={stats?.team_count ?? "-"} testId={DASHBOARD.statTeam} />
        <StatCard icon={Sparkles} label="Servicios activos" value={stats?.services_count ?? "-"} testId={DASHBOARD.statServices} />
        <StatCard icon={Users} label="Pacientes" value={stats?.patients_count ?? "-"} testId={DASHBOARD.statPatients} />
        <StatCard icon={Calendar} label="Turnos" value={stats?.appointments_count ?? "-"} testId={DASHBOARD.statAppointments} />
      </div>

      <FollowUpKpiCard />

      <div className="bg-white border border-border rounded-xl p-8 shadow-sm">
        <h2 className="font-serif text-2xl text-foreground mb-2">Bienvenida a la base de tu plataforma</h2>
        <p className="text-base text-muted-foreground leading-relaxed max-w-2xl">
          Desde aca podes gestionar la Agenda y las fichas de Pacientes de la clínica.
        </p>
      </div>
    </div>
  );
}
